export default __webpack_public_path__ + "6c3bb044ff45f4cf4091fbc1575c64b5.svg";